<template>
    <div>
        <div v-for="(item,index) in teamList" :key="index" class="d-flex  team">
            <div class="w-50 d-flex flex-wrap align-items-center">
                <div class="w-50 d-center-start mb-2">
                    <left-text leftText="团队类型"/><span>{{item.team_type==1?'旅游团':'会议团'}}</span>
                    <span v-if="item.order_type==1">({{item.num}}人)</span>
                </div>
                <div class="w-100 d-center-start mb-2">
                    <left-text leftText="团号"/><span>{{item.title}}</span>
                </div>
                <div class="w-100 d-center-start mb-2">
                    <left-text leftText="入离日期"/><span>{{item.date_in | formatTimestamp()}} <span class="hlie">至</span> {{item.date_out | formatTimestamp()}}</span>
                    <p class="ml-1 hlie"><span>共{{((item.date_out - item.date_in)/86400).toFixed(0)}}晚</span></p>
                </div>
                <div class="w-50 d-center-start mb-2">
                    <left-text leftText="预订人"/><span>{{item.send_name}}</span>
                </div>
                <div class="w-100 d-center-start mb-2">
                    <left-text leftText="预订单位"/><span>{{item.travel_title}}</span>
                </div>
            </div>
            <div class="roomsex">
                <table border="1" align="center" cellpadding="10" cellspacing="5" class=" roomsex-table" v-if="item.order_type==1&&item.need_mode!=1">
                    <thead>
                    <tr>
                        <th colspan="4">房间报价</th>
                    </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th>房型</th>
                            <th>间数</th>
                            <th>单价</th>
                        </tr>
                    </thead>
                    <tbody v-for="(meet,meetIndex) in item.room_need_arr" :key="meetIndex">
                        <tr>
                            <td>{{meet.label}}</td>
                            <td>{{meet.room_num}}</td>
                            <td>{{meet.offer_price}}元/晚</td>
                        </tr>
                    </tbody>
                </table>
                <!--日期模式-->
                <table  border="1" align="center" cellpadding="10" cellspacing="5" class="roomsex-table" v-if="item.order_type==1&&item.need_mode==1">
                    <thead>
                    <tr>
                        <th colspan="4">房间报价</th>
                    </tr>
                    </thead>
                    <thead>
                    <tr>
                        <th>日期</th>
                        <th>房型</th>
                        <th>间数</th>
                        <th>单价</th>
                    </tr>
                    </thead>
                    <tbody v-for="(arrs,index) in item.room_need_arr":key="index" v-if="index<=2">
                        <tr>
                        <td  :rowspan="offer_info(arrs.offer_info)">
                            {{arrs.date | formatTimestamp(2)}}
                        </td>
                        </tr>
                        <tr v-for="(item,i)  in arrs.offer_info" :key="item.i" > 
                        <td>
                            {{item.type | formatVar('roomStyle')}}
                        </td>
                        <td>{{item.room_num}} 间</td>
                        <td><span>{{item.offer_price}}元/晚</span></td>
                        </tr>
                    </tbody>
                </table>
                <table border="1" align="center" cellpadding="10" cellspacing="5" class="roomsex-table"  v-if="item.meeting_need_arr.length>0">
                    <thead>
                    <tr>
                        <th colspan="6">会议报价</th>
                    </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th>开会日期</th>
                            <th>时段</th>
                            <th>布局</th>
                            <th>出席人数</th>
                            <th>要求面积</th>
                            <th>价格</th>
                        </tr>
                    </thead>
                    <tbody v-for="meet in item.meeting_need_arr" :key="meet.date" >
                        <tr>
                        <td>{{meet.date | formatTimestamp()}}</td>
                        <td>{{meet.timeslot| formatVar('TimeSlots')}}</td>
                        <td>{{meet.type | formatVar('LayoutTypes')}}</td>
                        <td>{{meet.num}}人</td>
                        <td>{{meet.area}}㎡</td>
                        <td><span>{{meet.offer_price}}</span>元</td>
                        </tr>
                    </tbody>
                    </table>
            </div>
            <div class="w-details" @click="goHotelDetail(item)">查看详情 </div>
            <!-- <el-button size="small" type="primary" @click="goHotelDetail(item)" class="w-6"></el-button> -->
        </div>
        <p class="mt-3 text-center" v-if="teamList.length<=0">未查询到数据</p>
        <el-pagination background layout="prev, pager, next" class="mt-4 pagination"  :page-size="3" v-if="teamList.length>0"
            :total="total" :current-page="Number(page)"
            @current-change="v => PostHotelsTeamList(v)"/>
    </div>
</template>
<script>
    import {mapGetters,mapActions,mapState} from 'vuex'
    export default {
        name: 'TeamList',
        props: {
            select_time: {},
            store_id:{}
        },
        data() {    
            return {
                teamList: [],
                page:1,
                total:0,
            }
        },
        watch: {
            select_time: {
                handler(newVal, oldVal) {
                    console.log(newVal)
                                        this.PostHotelsTeamList();
                },
            immediate: true // 立即触发一次
            }
        },
        methods: {
            ...mapActions(['HotelsTeamList']),
            PostHotelsTeamList(v=1){
                let TeamList=[
                    {
                        title: "旅游团",
                        send_name:'预订人',
                        team_type:'2',
                        meeting_need_arr:[{area: 20,date: 1750694400,id: "2386,阿松大",num: 20,offer_id: "2386",offer_price: 20,offer_title: "阿松大",timeslot: 4,type: 2}]
                    }
                ]
                let data={
                    select_time: this.select_time,
                    page:v?v:this.page,
                    store_id:this.store_id,
                    num:3
                }
                this.HotelsTeamList({
                    data,
                    successFun:(res)=>{
                        this.teamList=res.list;
                         this.total=res.count;
                    }
                });
            },
                //订单详情页
                goHotelDetail (e) {
                    let cardItem=e;
                    let routeUrl = this.$router.resolve({
                        name: 'OrderDetail',
                        query: {
                            orderType: 3,
                            orderId: cardItem.oid,
                            // storeId: this.storeInfo.type == 2 ? cardItem.main_id : (cardItem.store_id || cardItem.appoint),
                        }
                    });
                    window.open(routeUrl.href, '_blank');
                },
            //展示房型、会议室图片
            offer_info(i){
                if(i){
                    return i.length+1
                }
            },
        }
    }
</script>
<style scoped  lang="scss">
    .align-items-center{
        max-height: 160px;
    }
    .roomsex-table{
        width: 100%;
        margin-top: 14px;
    }
    .roomsex .roomsex-table:nth-child(1){
        margin-top: 0;
    }
    .team{
        background-color: #f5f5f5;
        padding: 12px;
        border-radius: 6px;
        justify-content: space-between;
        overflow: hidden;
        margin-top: 20px;
    }
    .team-list{
        width: 100%;
        margin-bottom: 10px;
        >div{
            width: 50%;
            display: flex;
        }
    }
    table{
        border-collapse:collapse;
        border-spacing:0;
    }
    .roomsex{
        justify-content:center;
        overflow: hidden;
        width: 39%;
        float: left;
    }
    .roomsex th, .roomsex td {
      padding: 6px 10px; /*设置单元格间距*/
      font-size: 12px;
      text-align:center;
  }
  .pagination{
    display: flex;
    justify-content: center;
  }
  .flex-wrap span{
    line-height: 18px;
  }
  .w-details{
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0 10px;
    cursor: pointer;
    color: var(--smtc-color-primary); 
  }
  .d-center-start{
    line-height: 20px;
  }
  .hlie{
    color: #999;
  }
</style>